import get from 'lodash/get';
import cloneDeep from 'lodash/cloneDeep';
import {modify} from "mythil/object";

export default function resetModelItemValues(model) {
    if(!get(model, 'itemData.finished_at')) { return model; }



    return modify(model, 'item.values', cloneDeep(model.itemData.value.values))

}